import { FaRegClock } from 'react-icons/fa'
import { Icon, IconProps, forwardRef } from '@chakra-ui/react'

export const OmClock = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={FaRegClock} />
))
